/* eslint-disable jsx-a11y/href-no-hash */
/* eslint-disable react/jsx-no-target-blank */
import classNames from 'classnames'
import { filter, size } from 'lodash'
import pluralize from 'pluralize'
import PropTypes from 'prop-types'
import React from 'react'
import { Marker } from 'react-google-maps'

import Button from 'components/Button'
import Buttons from 'components/Buttons'
import Carousel from 'components/Carousel'
import CarouselItem from 'components/CarouselItem'
import DateTime from 'components/DateTime'
import FirebaseImage from 'components/FirebaseImage'
import Map from 'components/Map'
import Icon from 'components/Icon'
import Image from 'components/Image'
import MediaObject from 'components/MediaObject'
import Meta from 'components/Meta'
import paths from 'constants/paths'
import { db } from 'data'
import createReport from 'libs/create-report'

import styles from './Report.module.scss'

function ReportCategoryModule({ icon, label, value }: props) {
  return (
    <div className="uk-card uk-card-blank uk-card-body">
      <div className="uk-h2">
        {value}
      </div>
      <MediaObject center inline>
        <Icon name={icon} />
        <span>
          {pluralize(label, value)}
        </span>
      </MediaObject>
    </div>
  )
}

function ReportConditionModule({ children, color, label }: props) {
  return (
    <div className={`uk-background-${color || label.toLowerCase()} uk-padding`}>
      <div className="uk-h3">
        {children}
      </div>
      {label}
    </div>
  )
}

function ReportCountModule({ label, value }: props) {
  return (
    <div className="uk-width-auto uk-text-center">
      <div className="uk-h3">
        {value}
      </div>
      {pluralize(label, value)}
    </div>
  )
}

export default class Report extends React.Component {
  static propTypes = {
    userEmail: PropTypes.string,
  }

  state = {
    report: null,
  }

  componentWillMount() {
    const { id } = this.props.match.params

    this.setState({ id })

    db.getFullReport(id).then((snapshot) => {
      const report = snapshot.val()

      if (report) {
        this.setState({ loading: false, report })
      } else {
        createReport(id).then((response) => {
          this.setState({ loading: false, report: response })
        })
      }
    })
  }

  getPdfUrl = () => {
    db.getReportPdfUrl(this.state.id)
      .then((response) => {
        this.setState({ pdfUrl: response })
      }, () => {
        return Promise.resolve(null)
      })
      .catch((error) => {
        //console.log('error', error)
      })
  }

  getYesOrNo = (value) => (value ? 'Y' : 'N')

  render() {
    const { userEmail } = this.props
    const { id, loading, report } = this.state

    if (!report) return null

    //console.log('report', report)

    const {
      areas,
      assessorEmail,
      coverImageUrl,
      creationDate,
      images,
      lat,
      lon,
      objects,
      sites,
      title = 'Unnamed Report',
      unassessedItems,
    } = report

    let pdfUrl = report.pdfUrl || this.state.pdfUrl

    if (!pdfUrl) {
      pdfUrl = this.getPdfUrl()
    }

    const items = {
      ...areas,
      ...sites,
      ...objects,
      ...unassessedItems,
    }

    const itemsObj = Object.keys(items)

    const areasCount = size(areas)
    const sitesCount = size(sites)
    const objectsCount = size(objects)

    const hazardsCount = size(filter(items, { hazards: true }))
    const interventionsCount = size(filter(items, { interventions: true }))
    const safetyPersonalHazardsCount = size(filter(items, { safetyHazards: true }))
    const uploadsCount = size(images)

    const conditionGoodCount = size(filter(items, { conditionNumber: 1 }))
    const conditionFairCount = size(filter(items, { conditionNumber: 2 }))
    const conditionPoorCount = size(filter(items, { conditionNumber: 3 }))
    const conditionBadCount = size(filter(items, { conditionNumber: 4 }))
    const conditionDestroyedCount = size(filter(items, { conditionNumber: 5 }))

    const hasMultipleItems = size(items) > 1

    const actions = (
      <Buttons align="right">
        {userEmail === assessorEmail &&
          <Button to={`${paths.REPORTS}/${id}/edit`}>Edit Report</Button>
        }
        {pdfUrl &&
          <Button to={pdfUrl}>Get PDF</Button>
        }
      </Buttons>
    )

    if (loading) return null

    return (
      <div className={classNames('Report', styles.this)}>
        <Meta title="Report" />
        <div className="uk-container">
          <div className="uk-section uk-section-default">
            <div className="uk-container uk-container-small">
              <div className="uk-margin-bottom">
                {actions}
              </div>
              <article>
                <div className="uk-card uk-card-default">
                  <div className={classNames('uk-card-media-top', styles['img-wrap'])}>
                    {/*
                    <div
                      className="uk-background-cover uk-height-medium"
                      style={{ backgroundImage: `url(${coverImageUrl})` }
                    />
                    */}
                    <Image src={coverImageUrl} className={styles.img} />
                  </div>
                  <header className="uk-card-header">
                    <div>
                      <MediaObject figure="right" reset="tablet">
                        <div>
                          <h3 className="uk-card-title uk-margin-remove-bottom">
                            {title}
                          </h3>
                          <div className="uk-text-meta uk-margin-remove-top">
                            <DateTime value={creationDate} />
                          </div>
                        </div>
                        <div className="uk-grid uk-grid-small">
                          <ReportCountModule label="Hazard" value={hazardsCount} />
                          <ReportCountModule label="Safety/Personal Hazard" value={safetyPersonalHazardsCount} />
                          <ReportCountModule label="Intervention" value={interventionsCount} />
                          <ReportCountModule label="Upload" value={uploadsCount} />
                        </div>
                      </MediaObject>
                    </div>
                  </header>
                  <div className="uk-card-body">
                    <div className="uk-child-width-expand@s uk-text-center uk-grid-divider uk-padding uk-grid" uk-grid="true">
                      <div className="uk-first-column">
                        <ReportCategoryModule icon="location" label="Area" value={areasCount} />
                      </div>
                      <div>
                        <ReportCategoryModule icon="home" label="Building" value={sitesCount} />
                      </div>
                      <div>
                        <ReportCategoryModule icon="tag" label="Object" value={objectsCount} />
                      </div>
                    </div>
                    <h3 className="uk-heading-line uk-text-center">
                      <span>Overall Condition</span>
                    </h3>
                    <div className="uk-grid-collapse uk-child-width-expand@s uk-text-center uk-grid">
                      <div className="uk-first-column">
                        <ReportConditionModule color="muted" label="Good">
                          {conditionGoodCount}
                        </ReportConditionModule>
                      </div>
                      <div>
                        <ReportConditionModule label="Fair">
                          {conditionFairCount}
                        </ReportConditionModule>
                      </div>
                      <div>
                        <ReportConditionModule label="Poor">
                          {conditionPoorCount}
                        </ReportConditionModule>
                      </div>
                      <div>
                        <ReportConditionModule color="very-bad" label="Bad">
                          {conditionBadCount}
                        </ReportConditionModule>
                      </div>
                      <div>
                        <ReportConditionModule label="Destroyed">
                          {conditionDestroyedCount}
                        </ReportConditionModule>
                      </div>
                    </div>
                  </div>
                  {lat && lon &&
                    <div className="uk-margin-top">
                      <hr />
                      <div className="uk-card-body">
                        <Map
                          containerElement={<div style={{ height: 300 }} />}
                          loadingElement={<div style={{ height: 300 }} />}
                          mapElement={<div style={{ height: 300 }} />}
                          defaultCenter={{ lat, lng: lon }}>
                          <Marker position={{ lat, lng: lon }} />
                        </Map>
                      </div>
                    </div>
                  }

                  <hr className="uk-margin-top" />

                  <div className="uk-card-body">
                    <Carousel nav={hasMultipleItems}>
                      <ul className="uk-slideshow-items">
                        {itemsObj.map((itemId) => {
                          const item = items[itemId]

                          console.log('item', item)

                          const {
                            category,
                            conditionNumber,
                            hazards,
                            imageUrl,
                            interventionRequired,
                            name,
                            notes,
                            safetyHazards,
                          } = item

                          if (!imageUrl) return null

                          return (
                            <CarouselItem image={imageUrl} key={itemId}>
                              {name &&
                                <h3 className="uk-margin uk-margin-remove-adjacent">
                                  {name}
                                </h3>
                              }
                              {category &&
                                <div className="uk-margin uk-text-meta">
                                  {category}
                                </div>
                              }
                              <div className="uk-margin">
                                {conditionNumber > 0 &&
                                  <div>
                                    Condition:
                                    {' '}
                                    <span className="uk-label uk-label-danger">
                                      {conditionNumber}
                                    </span>
                                  </div>
                                }
                                <div>
                                  Hazards:
                                  {' '}
                                  <span className="uk-label uk-label-danger">
                                    {this.getYesOrNo(hazards)}
                                  </span>
                                </div>
                                <div>
                                  Safety Hazards:
                                  {' '}
                                  <span className="uk-label uk-label-danger">
                                    {this.getYesOrNo(safetyHazards)}
                                  </span>
                                </div>
                                <div>
                                  Intervention Recommended:
                                  {' '}
                                  <span className="uk-label uk-label-danger">
                                    {this.getYesOrNo(interventionRequired)}
                                  </span>
                                </div>
                                {notes &&
                                  <div>
                                    Notes:
                                    <p>
                                      {notes}
                                    </p>
                                  </div>
                                }
                              </div>
                              <p>
                                <a href={imageUrl} target="_blank">View media</a>
                              </p>
                            </CarouselItem>
                          )
                        })}
                      </ul>
                      {hasMultipleItems &&
                        <ul className="uk-thumbnav uk-flex-center uk-margin" uk-margin="true">
                          {itemsObj.map((itemId, i) => {

                            if (!items[itemId].imageRef) return null

                            return (
                              <li uk-slideshow-item={i} key={itemId}>
                                <a href="#" aria-label={`Go to item #${++i}`}>
                                  {/*
                                  <Image
                                    src={items[itemId].imageUrl}
                                    className={styles['carousel--nav--item--img']}
                                  />
                                  */}
                                  {/**/}
                                  <FirebaseImage
                                    imageRef={items[itemId].imageRef}
                                    thumbnail
                                    className={styles['carousel--nav--item--img']}
                                  />
                                  {/**/}
                                </a>
                              </li>
                            )
                          })}
                        </ul>
                      }
                    </Carousel>
                  </div>
                </div>
              </article>
              <footer className="uk-margin-top">
                {actions}
              </footer>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/Report/Report.js